import React from "react";

import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";

const RaindropBackButtonPanel = () => {
  return (
    <div className="flex w-full">
      <RaindropButton
        title="Back"
        icon="fa-chevron-left"
        style={ButtonStyle.Tertiary}
        onClick={() => {
          window.history.back();
        }}
      />
    </div>
  );
};

export default RaindropBackButtonPanel;
